import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthData";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  getAllEmployeeRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
} from "../../../../actions/index";

import { connect } from "react-redux";

export class SoldMonth extends Component {
  componentDidMount = async () => {
    await this.props.ensureCurrentMonthStatsRedux();
    this.props.getAllSourcingMonthStatsRedux();
  };

  render() {
    const { agentMonthStats, allEmployees } = this.props;
    return (
      <Fragment>
        <Breadcrumb title="Monthly" parent="Wholesale Management/ Order" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="col-sm-12">
            <div className="card">
              <div
                className="card-header"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h5>
                  <i
                    className="icofont-list"
                    style={{
                      fontSize: "130%",
                      marginRight: "5px",
                      color: "darkblue",
                    }}
                  ></i>
                  {this.props.match.params.agent}
                </h5>
              </div>
              <div className="card-body">
                <div className="clearfix"></div>
                <div id="basicScenario" className="product-physical">
                  <Datatable
                    history={this.props.history}
                    myData={agentMonthStats}
                    agent={this.props.match.params.agent}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const agent = ownProps.match.params.agent;
  return {
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active"
    ),
    agentMonthStats: state.sourcings.monthStats
      .filter((month) => month.byAgent && month.byAgent[agent])
      .map((month) => ({ month: month.month, ...month.byAgent[agent] })),
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
})(SoldMonth);
